<template lang="pug">
.gallery
  .gallery__container(:class="{ 'gallery__container--center': 4 }")
    .gallery__item
      img.gallery__img(:src="require('../assets/dirty-bird-since.jpg')")
    .gallery__item
      img.gallery__img(:src="require('../assets/atl.jpg')")
    .gallery__item
      img.gallery__img(:src="require('../assets/red-helmet.jpg')")
    .gallery__item
      img.gallery__img(:src="require('../assets/frost.jpg')")
    .gallery__item
      img.gallery__img(:src="require('../assets/af_23_web_dbg_filter__london_studio.jpg')")
</template>

<script>
// import debug from 'debug'

// const log = debug('component:Gallery')

export default {
  name: 'Gallery',
  data () {
    return {
      memes: [],
      loading: false,
      error: false,
    }
  },
  created () {
    this.loading = true
  },
}
</script>

<style lang="scss" scoped>
.gallery {
  padding: 4rem 1rem 0;

  &__spinner {
    width: 3rem;
    animation: spin 900ms infinite;
  }

  &__container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: 47.375rem;
    margin-left: auto;
    margin-right: auto;
    widows: 100%;

    &--center {
      justify-content: center;
    }
  }

  &__item {
    flex: 0 1 auto;
    padding: 1rem;
    width: 100%;
  }

  &__img {
    max-width: 100%;
  }

  @include media-breakpoint-up(sm) {
    &__item {
      width: calc(50% - 2px);
    }
  }

  @include media-breakpoint-up(md) {
    &__item {
      width: calc((100% / 2) - 2px);
    }
  }
}

@keyframes spin {
    from {transform:rotate(0deg);}
    to {transform:rotate(360deg);}
}
</style>
